<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
    <div class="logo">
        <img class="logo-icon" src="assets/images/logos/logo3.png">
        <span class="logo-text secondary-text">Juan Bautista</span>
        
        
        
    </div>
    <button mat-icon-button class="toggle-sidebar-folded"
                (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

   

    

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
     fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
        
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" [src]="profile[4]">
            
        </div>

    </div>

    <div class="navbar-content">

        
        
        
        <div class="h3 perfil email hint-text mt-8" [routerLink]="'pages/profile'">{{profile[0]}}</div>
        
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>
    <div style="text-align: center; padding-bottom: 10px;">
        <span><a href="http://www.impeltechnology.com/portal" target="_blank">IMPEL</a></span>
    </div>

</div>
